import { Component, Components } from "../../utils/components";
import { HtmlHelpers, AxiosHelpers } from "../../utils/helpers";
import axios from "../../../../node_modules/axios/index";
export class BaseSubmittableForm extends Component {
  constructor(element) {
    super(element);
    this.form = element.querySelector("form");

    if (!this.form) {
      this.form = element;
    }

    this.lastButtonClicked = null;
    this.invalidScrolling = true;
    this.submitting = false;
  }

  load() {
    this.setupForm();

    this._bindInternalFields();

    this.bindFields();
    this.formReady();
  } // Can be overidden if needed


  formReady() {}

  isValid() {
    //return true;
    let $form = $(this.form); //$.validator.unobtrusive.parse($form);

    $form.validate();
    return $form.valid();
  }

  delay(milliseconds) {
    const promise = new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve();
      }, milliseconds);
    });
    return promise;
  }

  setupForm() {
    this.form.addEventListener("submit", event => {
      event.preventDefault();

      if (this.isValid()) {
        this.submit(this.lastButtonClicked ? this.lastButtonClicked.value : null);
        return;
      }

      if (this.invalidScrolling) {
        this.scrollToFirstInvalid();
      }
    });
  }

  _bindInternalFields() {
    const buttons = this.form.querySelectorAll("input[type=button],button");

    for (const but of buttons) {
      but.addEventListener("click", e => {
        this.lastButtonClicked = e.target;
      });
    }
  } // This is meant to be overidden


  bindFields() {}

  isSubmitting() {
    return this.submitting;
  }

  beginSubmitting() {
    this.form.classList.add("submitting");
    this.submitting = true;
  }

  endSubmitting() {
    this.form.classList.remove("submitting");
    this.submitting = false;
  }

  scrollToTopOfElement(element, offsetY = 0) {
    if (!element) return;
    HtmlHelpers.scrollToTopOfElement(element, offsetY);
  }

  getBaseScrollOffset() {
    let offsetY = 0;
    const mainHeaderElement = document.querySelector(".headerBackground");

    if (mainHeaderElement) {
      offsetY = -mainHeaderElement.offsetHeight;
    }

    offsetY -= 90;
    return offsetY;
  }

  scrollToFirstInvalid() {
    let offsetY = this.getBaseScrollOffset();
    let element = this.form.querySelector(".input-validation-error");

    if (HtmlHelpers.isMobileWidthOrLess()) {
      const inputItemElement = element.closest(".row");

      if (inputItemElement) {
        element = inputItemElement;
      }
    } else {
      const blockElement = element.closest(".block");

      if (blockElement) {
        element = blockElement;
      }
    }

    this.scrollToTopOfElement(element, offsetY);
  }

  scrollToTop(offsetY = 0) {
    this.scrollToTopOfElement(this.element, offsetY);
  }

  onProgress(progressEvent) {// Stub meant to be overidden
  }

  doSubmit(areas, action = null) {
    if (areas === null) {
      areas = ["#" + this.form.id];
    }

    const promise = new Promise((resolve, reject) => {
      const formData = new FormData(this.form);

      if (action) {
        formData.append("Action", action);
      }

      const titleBeforeUpload = document.title;
      const request = {
        method: this.form.method,
        url: this.form.action,
        headers: {
          'X-Requested-With': "XMLHttpRequest"
        },
        data: formData,
        maxRedirects: 1,
        onUploadProgress: progressEvent => {
          this.onProgress(progressEvent);
        }
      };
      axios.request(request).then(result => {
        // handle success
        document.title = titleBeforeUpload;

        if (!AxiosHelpers.tryClientSideRedirect(result)) {
          if (result.status === 200) {
            if (areas.length > 0) {
              HtmlHelpers.swapOutAreas(result.data, areas);
            }

            this._bindInternalFields();

            this.bindFields();
            Components.update();
            return resolve(result);
          } else {
            reject(result);
          }
        } else {
          resolve(null);
        }
      }).catch(err => {// handle error
      });
    });
    return promise;
  } // This is meant to be overidden


  submit(action) {}

}